import { http } from '../api/client';

export const ideaService = {
    getIdeas: async (config) => http.get('/ideas', config),
    getIdeaById: async (id) => http.get(`/ideas/${id}`),
    createIdea: async (data, config) => http.post('/ideas/create', data, config),
    updateIdea: async (id, data, config) => http.post(`/ideas/update/${id}`, data, config),
    getIdeaFile: async (id) => http.get(`/ideas/${id}/file`),
    updateIdeaFile: async (id, data, config) => http.post(`/ideas/update-file/${id}`, data, config),
}